{
  "nl": {
    "linkShortener": {
      "hints": {
        "copied": "Gekopieerd naar klembord!",
        "shortcode": "We hebben een willekeurige gewenste URL voor je gegenereerd. Stel hier je gewenste URL in."
      },
      "labels": {
        "shortcode": "Korte link",
        "url": "URL"
      }
    }
  }
}
